import IpaLogo from "./Logos/ipa-nowy-targ.png";
import BochniakLogo from "./Logos/bochniak-logo.jpg";
import ZajazdLogo from "./Logos/zajazd_czorsztynski.jpg";
import ZnaczkiLogo from "./Logos/znaczki-logojpg.jpg";
import CzteryPory from "./Logos/logo-cztery.png";
import EkoLogo from "./Logos/logo-ekomuzeum.jpeg";
import CrosnaLogo from "./Logos/Crosna-spa-logo.jpg";


export const partners = [
    {
        logo: EkoLogo,
        link: "https://sprezyna.org/ekomuzeum-dziedziny-dunajca/histora-wspolpracy-co-to-jest-ekomuzeum",
        alt: "Ekomuzeum dziedziny dunajca logo"
    },
    {
        logo: BochniakLogo,
        link: "https://ubochniaka.pl/",
        alt: "U Bochniaka logo"
    },
    {
        logo: CzteryPory,
        link: "https://czorsztyn.czterypory.info/wynajem/",
        alt: "Cztery pory roku logo"
    },
    {
        logo: ZajazdLogo,
        link: "https://www.czorsztynski.pl/",
        alt: "Zajazd Czorsztynski logo"
    },
    {
        logo: ZnaczkiLogo,
        link: "https://www.znaczki-turystyczne.pl/",
        alt: "  Znaczki turystyczne logo"
    },
    {
        logo: IpaLogo,
        link: "https://www.ipanowytarg.pl/",
        alt: "IPA Nowy Targ logo"
    },
    {
        logo: CrosnaLogo,
        link: "https://www.crosna.pl/",
        alt: "Crosna Spa logo"
    },
];